import script from "./PresetFiltrosSalvos.vue?vue&type=script&setup=true&lang=js"
export * from "./PresetFiltrosSalvos.vue?vue&type=script&setup=true&lang=js"

import "./PresetFiltrosSalvos.vue?vue&type=style&index=0&id=0254db44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0254db44"]])

export default __exports__